var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 3.45392C14.6654 3.05004 14.6654 2.84811 14.5855 2.7546C14.5162 2.67346 14.4122 2.6304 14.3059 2.63877C14.1833 2.64842 14.0405 2.79121 13.7549 3.0768L11.332 5.49967L13.7549 7.92255C14.0405 8.20813 14.1833 8.35093 14.3059 8.36058C14.4122 8.36895 14.5162 8.32589 14.5855 8.24475C14.6654 8.15124 14.6654 7.9493 14.6654 7.54543V3.45392Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 4.03301C1.33203 2.9129 1.33203 2.35285 1.55002 1.92503C1.74176 1.5487 2.04773 1.24274 2.42405 1.05099C2.85187 0.833008 3.41193 0.833008 4.53203 0.833008H8.13203C9.25214 0.833008 9.81219 0.833008 10.24 1.05099C10.6163 1.24274 10.9223 1.5487 11.114 1.92503C11.332 2.35285 11.332 2.9129 11.332 4.03301V6.96634C11.332 8.08645 11.332 8.6465 11.114 9.07432C10.9223 9.45065 10.6163 9.75661 10.24 9.94835C9.81219 10.1663 9.25214 10.1663 8.13203 10.1663H4.53203C3.41193 10.1663 2.85187 10.1663 2.42405 9.94835C2.04773 9.75661 1.74176 9.45065 1.55002 9.07432C1.33203 8.6465 1.33203 8.08645 1.33203 6.96634V4.03301Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.b7198c90769d6cd4d8c3c0a3ff95d742.svg";
export { ForwardRef as ReactComponent };